import {NgModule, Optional, SkipSelf} from '@angular/core';

import {AccountSwitcherComponent} from "./modules/header/account-switcher/account-switcher.component";
import {AlertListComponent} from "./modules/alert/alert-list.component";
import {AppComponent} from "./modules/app.component";
import {SeoHeadDirective} from "./modules/link/seo-head.directive";
import {ConfirmDialogComponent} from "./modules/common/confirm-dialog/confirm-dialog.component";
import {CustomHeaderComponent} from "./modules/header/custom-header/custom-header.component";
import {DebugComponent} from "./modules/common/debug/debug.component";
import {FacebookProgressModalComponent} from "./modules/social/facebook/facebook-progress-modal.component";
import {FooterComponent} from "./modules/footer/footer.component";
import {GeneralAlertComponent} from "./modules/alert/templates/general-alert/general-alert.component";
import {GeneralErrorPopupComponent} from "./modules/validation/general-error-popup.component";
import {GlobalMessageComponent} from "./modules/header/global-message/global-message.component";
import {HeaderComponent} from "./modules/header/header.component";
import {MainHeaderComponent} from "./modules/header/main-header/main-header.component";
import {LandingComponent} from "./modules/landing/landing.component";
import {LoginModalComponent} from "./modules/login/login-modal.component";
import {LogoutComponent} from "./modules/auth/logout.component";
import {MarketingPageModule} from "./modules/marketing-pages/marketing-page.module";
import {NavCategoryComponent} from "./modules/marketing-pages/placeholder/nav-category/nav-category.component";
import {PcUpsellModalComponent} from "./modules/cart/pc-upsell/pc-upsell-modal.component";
import {PreheaderComponent} from "./modules/header/preheader/preheader.component";
import {ReferralCreditComponent} from "./modules/referral/referral-credit.component";
import {ReloadComponent} from "./modules/common/reload.component";
import {ShareListComponent} from "./modules/social/share-list.component";
import {
    SideNavAccountSwitcherComponent
} from "./modules/header/side-nav-account-switcher/side-nav-account-switcher.component";
import {WelcomeModalComponent} from "./modules/welcome/welcome-modal.component";
import {ProductModule} from "./modules/product/product.module";
import {SharedModule} from "./shared.module";
import {ProductSelectionModule} from "./modules/product-selection/product-selection.module";
import {RouterModule} from "@angular/router";
import {PaymentCallbackComponent} from "./modules/payment/payment-callback.component";
import {LandingPageComponent} from "./modules/landing/landing-page.component";
import {PayPalTokenComponent} from "./modules/payment/paypal/paypal-token.component";
import {LocaleModule} from "./modules/locale/locale.module";

//This Module hosts all Components/Directives/Pipes that are not being shared in multiple places
// and don't have their own feature modules yet.
@NgModule({
    imports: [
        ProductModule,
        ProductSelectionModule,
        RouterModule,
        SharedModule,
        MarketingPageModule,
        LocaleModule
    ],
    declarations: [
        AccountSwitcherComponent,
        AlertListComponent,
        AppComponent,
        SeoHeadDirective,
        ConfirmDialogComponent,
        CustomHeaderComponent,
        DebugComponent,
        FacebookProgressModalComponent,
        FooterComponent,
        GeneralAlertComponent,
        GeneralErrorPopupComponent,
        GlobalMessageComponent,
        HeaderComponent,
        MainHeaderComponent,
        LandingComponent,
        LandingPageComponent,
        LoginModalComponent,
        LogoutComponent,
        NavCategoryComponent,
        PaymentCallbackComponent,
        PayPalTokenComponent,
        PcUpsellModalComponent,
        PreheaderComponent,
        ReferralCreditComponent,
        ReloadComponent,
        ShareListComponent,
        SideNavAccountSwitcherComponent,
        WelcomeModalComponent
    ],
    exports: [
        AccountSwitcherComponent,
        AlertListComponent,
        AppComponent,
        SeoHeadDirective,
        ConfirmDialogComponent,
        CustomHeaderComponent,
        DebugComponent,
        FacebookProgressModalComponent,
        FooterComponent,
        GeneralAlertComponent,
        GeneralErrorPopupComponent,
        GlobalMessageComponent,
        HeaderComponent,
        MainHeaderComponent,
        LandingComponent,
        LandingPageComponent,
        LoginModalComponent,
        LogoutComponent,
        NavCategoryComponent,
        PaymentCallbackComponent,
        PayPalTokenComponent,
        PcUpsellModalComponent,
        PreheaderComponent,
        ReferralCreditComponent,
        ReloadComponent,
        ShareListComponent,
        SideNavAccountSwitcherComponent,
        WelcomeModalComponent
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() core: CoreModule){
        if (core) {
            throw new Error("Import core module only in the root module");
        }
    }
}
